var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-row',{staticStyle:{"margin-bottom":"12px","margin-top":"12px"},attrs:{"type":"flex"}},[_c('a-col',[_c('strong',{staticStyle:{"font-size":"25px"}},[_vm._v("Bimbingan "+_vm._s(_vm.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }